/// <reference path="../_references.js" />

//function onAjaxStart() {
//    mActivityNotification.addNotification('ajax start');
//}

//function onAjaxSuccess() {
//    mActivityNotification.addNotification('ajax success');
//}

//function onAjaxFailure() {
//    mActivityNotification.addNotification('ajax fail');
//}

var gAjaxIsInitialized = false,
mIsInError = false,
mIsSystemBroken = false;
function initializeAjax() {
    "use strict";
    if (!gAjaxIsInitialized) {
        if (document.domain.indexOf('veritracks') !== -1) {
            try {
                //document.domain = 'veritracks.com';
            } catch (e) {
                alert('round robin not configured correctly.');
            }
        }
        $.ajaxSetup({
            'contentType': 'application/json; charset=utf-8',
            'cache': false,
            'timeout': 60 * 5 * 20000, //60 * 5 * 1000, // 5 minutes //
            'crossDomain': true,
            'async': true
        });
        // next line enables cross domain
        $.support.cors = true;

//        $.ajaxStart(onAjaxStart);
//        $.ajaxSuccess(onAjaxSuccess);
//        $.ajaxError(onAjaxFailure);

        gAjaxIsInitialized = true;
    }
}

function catastrophicErrorHandler(XMLHttpRequest, textStatus, errorThrown) {
    "use strict";

    var lResult = XMLHttpRequest.status === 500 && !isNullOrUndefined(XMLHttpRequest.responseText) && XMLHttpRequest.responseText.search(/Authenticate Failed/) === -1 && XMLHttpRequest.responseText.search(/AssignConnectionString Failed/) === -1,
        lIsInvalidToken = false,
        lExceptionMessage = 'unknown error';
    
    if (!mIsInError && lResult) {
        mIsInError = true;
//        alert('The server has experienced a severe problem. You will be redirected to the login page. If you continue to experience this error, please contact STOP LLC for support.<br/>Status: ' + XMLHttpRequest.status + '<br/>' +
        //            XMLHttpRequest.responseXML.text.substring(6, XMLHttpRequest.responseXML.text.length));
        if (!isNullOrUndefined(XMLHttpRequest.responseXML)) {
            if (!isNullOrUndefined(XMLHttpRequest.responseXML.text)) {
                var lInvalidTokenIndex = XMLHttpRequest.responseXML.text.indexOf("InvalidToken"),
                    lMultiLoginIndex = XMLHttpRequest.responseXML.text.indexOf("UserLoggedInElseWhere");

                lIsInvalidToken = (lInvalidTokenIndex !== -1);
                if (lMultiLoginIndex !== -1) {
                    var lErrorText = "<Fault xmlns=\"http://schemas.microsoft.com/ws/2005/05/envelope/none\"><Code><Value></Value></Code><Reason><Text xml:lang=\"en-US\">The current user has logged in at another location and has been logged out at this location.</Text></Reason><Detail><FaultBase xmlns=\"www.veritracks.com\" xmlns:i=\"http://www.w3.org/2001/XMLSchema-instance\"><InnerFault i:nil=\"true\"/><Message></Message></FaultBase></Detail></Fault>";
                    lExceptionMessage = lErrorText;//XMLHttpRequest.responseXML.text;
                } else {
                    lExceptionMessage = XMLHttpRequest.responseXML.text;
                }
            } else if (!isNullOrUndefined(XMLHttpRequest.responseXML.childNodes) && !isNullOrUndefined(XMLHttpRequest.responseXML.childNodes[0]) && !isNullOrUndefined(XMLHttpRequest.responseXML.childNodes[0].textContent)) {
                var lInvalidTokenIndex = XMLHttpRequest.responseXML.childNodes[0].textContent.indexOf("InvalidToken"),
                    lMultiLoginIndex = XMLHttpRequest.responseXML.childNodes[0].textContent.indexOf("UserLoggedInElseWhere");

                lIsInvalidToken = (lInvalidTokenIndex !== -1);
                if (lMultiLoginIndex !== -1) {
                    var lErrorText = "<Fault xmlns=\"http://schemas.microsoft.com/ws/2005/05/envelope/none\"><Code><Value></Value></Code><Reason><Text xml:lang=\"en-US\">The current user has logged in at another location and has been logged out at this location.</Text></Reason><Detail><FaultBase xmlns=\"www.veritracks.com\" xmlns:i=\"http://www.w3.org/2001/XMLSchema-instance\"><InnerFault i:nil=\"true\"/><Message></Message></FaultBase></Detail></Fault>";
                    lExceptionMessage = lErrorText;//XMLHttpRequest.responseXML.text;
                }
                else {
                    lExceptionMessage = XMLHttpRequest.responseXML.childNodes[0].textContent;
                }
            }
        } else {
            lExceptionMessage = '';
        }
        if (lIsInvalidToken) {
            veritracks.system.redirectToLogin();
        } else if (errorThrown === 'Internal Server Error') {
            lResult = false;
            // no need for user to view error message outside of dev/testing
            //veritracks.system.raiseFailure(lExceptionMessage);
        }
        //else if (window.location.href.indexOf('ccount') === -1) {
        //    window.location.href = 'Interface/fail.htm';
        //} else {
        //    window.location.href = 'fail.htm';
        //}
        //veritracks.system.redirectToLogin();
        mIsInError = false;
    }

    return lResult;
}
//function ErrorHandler(XMLHttpRequest, textStatus, errorThrown) {
//    "use strict";
//    $('#uDebugOutput').html("Error. Status: " + XMLHttpRequest.status + ", Message: " + XMLHttpRequest.responseText);
//}

function isPageStateStatic(aState) {
    "use strict";
    var lIsStatic = (!isNullOrUndefined(aState.CallState) && !isNullOrUndefined(aState.ResponseState));

    if (lIsStatic) {
        lIsStatic = (aState.CallState.Tab === aState.ResponseState.Tab);
    }

    if (lIsStatic) {
        lIsStatic = (aState.CallState.Layout === aState.ResponseState.Layout);
    }

    if (lIsStatic) {
        lIsStatic = (aState.CallState.Primary === aState.ResponseState.Primary);
    }

    if (lIsStatic) {
        lIsStatic = (aState.CallState.Secondary === aState.ResponseState.Secondary);
    }

//    if (lIsStatic) {
//        lIsStatic = (aState.CallState.Tertiary === aState.ResponseState.Tertiary);
//    }
    return lIsStatic;
}
function getAPI(){
    return gServerList.API.MobileApi;
}
function getServiceUrl() {    
    return gServiceUrlList ? gServiceUrlList : gServerList.veritracks[0];
}

(function(){
    function callApi(aMethod,aUrl,aParams,aOnSuccess,aOnFailure){
        var mStart = new Date(),
        mEnd = null,
        mMSeconds = 0,
        lCallState,
        lResponseState,
        aCheckState = false,
        lBypassState = false,
        aOutParams ={},
        lServiceUrl,
        lRequest;

        if (!isNullOrUndefined(mStateManager)) {
            lCallState = mStateManager.getSystemState();
        }
        initializeAjax();
        lServiceUrl = getServiceUrl();
        if (!isNullOrUndefined(lBypassState)) {
            lBypassState = !aCheckState;
        }
        var aApi = {
            'type': aMethod,
            'url': lServiceUrl + aUrl,
            
            'async': true,
            'crossDomain': true,
            'success': function (aServiceObject) {
                mEnd = new Date();
                mMSeconds = mEnd.getTime() - mStart.getTime();
                if (!isNullOrUndefined(mStateManager)) {
                    lResponseState = mStateManager.getSystemState();
                }
    
                if (lBypassState || isPageStateStatic({ 'CallState': lCallState, 'ResponseState': lResponseState })) {
                    if (!isNullOrUndefined(aOnSuccess)) {
                        if (!isNullOrUndefined(aServiceObject)) {
                            if (!isNullOrUndefined(aServiceObject.ExtraData)) {
                                aOnSuccess(aOutParams, aServiceObject.Data, aServiceObject.ExtraData, { 'CallState': lCallState, 'ResponseState': lResponseState });
                            }
                            else if (!isNullOrUndefined(aServiceObject.Data)) {
                                aOnSuccess(aOutParams, aServiceObject.Data, { 'CallState': lCallState, 'ResponseState': lResponseState });
                            } else {
                                aOnSuccess(aOutParams, aServiceObject, { 'CallState': lCallState, 'ResponseState': lResponseState });
                            }
                        } else {
                            aOnSuccess(aOutParams, aServiceObject);
                        }
                    }
                }
            },
            "error": function (XMLHttpRequest, textStatus, errorThrown) {
                var lIsCatastrophic = catastrophicErrorHandler(XMLHttpRequest, textStatus, errorThrown);
                if (!lIsCatastrophic && !mIsInError && textStatus === 'timeout') {
                    mIsInError = true;
                    mActivityNotification.addNotification(localizeWrapper('cDefaultNetworkError') + textStatus);
                    mIsInError = false;
                }
                if (!lIsCatastrophic && !mIsInError && !isNullOrUndefined(aOnFailure)) {
                    aOnFailure(aOutParams, XMLHttpRequest, textStatus, errorThrown, this);
                } else if (!lIsCatastrophic && !mIsInError && isNullOrUndefined(aOnFailure)) {
                    window.location.hash = encodeURIComponent(window.location.hash);
                }
            }
        };
        aApi.headers = {
            "aSecurityToken": veritracks.security.controller.tryGetSecurityToken(),
        };
        if(aMethod == 'GET'){
            aApi.contentType = "application/json; charset=utf-8";
            
        }else {
            if(aParams){
                aApi.dataType =  'json';
                aApi.data = JSON.stringify(aParams);
            }
        }
        lRequest = $.ajax(aApi);
        return lRequest;
    }
    var  Fetcher = {};
    Fetcher.Get = function(aURL,_OnSuccess,_OnFailure){
        callApi("GET",aURL,null,_OnSuccess,_OnFailure);
    };
    Fetcher.Post = function(aURL,aParams,_OnSuccess,_OnFailure){
        callApi("POST",aURL,aParams,_OnSuccess,_OnFailure);
    };
    Fetcher.Put = function(aURL,aParams,_OnSuccess,_OnFailure){
        callApi("PUT",aURL,aParams,_OnSuccess,_OnFailure);
    };
    window.Fetcher = Fetcher;
})();


function callAjax(aMethod, aParams, aOnSuccess, aOnFailure, aOutParams, aCheckState) {
    "use strict";
    var mStart = new Date(),
        mEnd = null,
        mMSeconds = 0,
        lCallState,
        lResponseState,
        lBypassState = false,
        lServiceUrl,
        lRequest;

    if (!isNullOrUndefined(mStateManager)) {
        lCallState = mStateManager.getSystemState();
    }
    initializeAjax();
    lServiceUrl = getServiceUrl();
    if (!isNullOrUndefined(lBypassState)) {
        lBypassState = !aCheckState;
    }
    lRequest = $.ajax({
        'type': 'POST',
        'url': lServiceUrl + "/" + aMethod,
        'headers': { 
            'Cache-Control':'no cache',
            'X-XSS-Protection':'1',
            'X-Content-Type-Options':'nosniff',
            'X-Frame-Options':'SAMEORIGIN'
        },
        'dataType': 'json',
        'data': JSON.stringify(aParams),
        'async': true,
        'crossDomain': true,
        'success': function (aServiceObject) {
            mEnd = new Date();
            mMSeconds = mEnd.getTime() - mStart.getTime();
            //            if (typeof mActivityNotification !== 'undefined') {
            //                mActivityNotification.addNotification(aMethod + ' took ' + mMSeconds);
            //            }
            if (!isNullOrUndefined(mStateManager)) {
                lResponseState = mStateManager.getSystemState();
            }

            if (lBypassState || isPageStateStatic({ 'CallState': lCallState, 'ResponseState': lResponseState })) {
                if (!isNullOrUndefined(aOnSuccess)) {
                    if (!isNullOrUndefined(aServiceObject)) {
                        if (!isNullOrUndefined(aServiceObject.ExtraData)) {
                            aOnSuccess(aOutParams, aServiceObject.Data, aServiceObject.ExtraData, { 'CallState': lCallState, 'ResponseState': lResponseState });
                        }
                        else if (!isNullOrUndefined(aServiceObject.Data)) {
                            aOnSuccess(aOutParams, aServiceObject.Data, { 'CallState': lCallState, 'ResponseState': lResponseState });
                        } else {
                            aOnSuccess(aOutParams, aServiceObject, { 'CallState': lCallState, 'ResponseState': lResponseState });
                        }
                    } else {
                        aOnSuccess(aOutParams, aServiceObject);
                    }
                }
            }
        },
        'error': function (XMLHttpRequest, textStatus, errorThrown) {
            var lIsCatastrophic = catastrophicErrorHandler(XMLHttpRequest, textStatus, errorThrown);
            if (!lIsCatastrophic && !mIsInError && textStatus === 'timeout') {
                mIsInError = true;
                mActivityNotification.addNotification(localizeWrapper('cDefaultNetworkError') + textStatus);
                mIsInError = false;
            }
            if (!lIsCatastrophic && !mIsInError && !isNullOrUndefined(aOnFailure)) {
                aOnFailure(aOutParams, XMLHttpRequest, textStatus, errorThrown, this);
            } else if (!lIsCatastrophic && !mIsInError && isNullOrUndefined(aOnFailure)) {
                window.location.hash = encodeURIComponent(window.location.hash);
            }
        }
    });

    return lRequest;
}
function callAjaxAPI(aType,token,aMethod, aParams, aOnSuccess, aOnFailure, aOutParams, aCheckState) {
    "use strict";
    var mStart = new Date(),
        mEnd = null,
        mMSeconds = 0,
        lCallState,
        lResponseState,
        lBypassState = false,
        lServiceUrl,
        lRequest;

    if (!isNullOrUndefined(mStateManager)) {
        lCallState = mStateManager.getSystemState();
    }
    initializeAjax();
    lServiceUrl = getAPI();
    if (!isNullOrUndefined(lBypassState)) {
        lBypassState = !aCheckState;
    }
    var req  = {
        'type': aType? aType :'POST',
        'url': lServiceUrl + "/" + aMethod,
        'headers': {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Cache-Control':'no cache',
            'X-XSS-Protection':'1',
            'X-Content-Type-Options':'nosniff',
            'X-Frame-Options':'SAMEORIGIN'
        },
        'async': true,
        'crossDomain': true,
        'success': function (aServiceObject) {
            mEnd = new Date();
            mMSeconds = mEnd.getTime() - mStart.getTime();
            if (!isNullOrUndefined(mStateManager)) {
                lResponseState = mStateManager.getSystemState();
            }

            if (lBypassState || isPageStateStatic({ 'CallState': lCallState, 'ResponseState': lResponseState })) {
                if (!isNullOrUndefined(aOnSuccess)) {
                    if (!isNullOrUndefined(aServiceObject)) {
                        if (!isNullOrUndefined(aServiceObject.ExtraData)) {
                            aOnSuccess(aOutParams, aServiceObject.Data, aServiceObject.ExtraData, { 'CallState': lCallState, 'ResponseState': lResponseState });
                        }
                        else if (!isNullOrUndefined(aServiceObject.Data)) {
                            aOnSuccess(aOutParams, aServiceObject.Data, { 'CallState': lCallState, 'ResponseState': lResponseState });
                        } else {
                            aOnSuccess(aOutParams, aServiceObject, { 'CallState': lCallState, 'ResponseState': lResponseState });
                        }
                    } else {
                        aOnSuccess(aOutParams, aServiceObject);
                    }
                }
            }
        },
        'error': function (XMLHttpRequest, textStatus, errorThrown) {
            var lIsCatastrophic = catastrophicErrorHandler(XMLHttpRequest, textStatus, errorThrown);
            if (!lIsCatastrophic && !mIsInError && textStatus === 'timeout') {
                mIsInError = true;
                mActivityNotification.addNotification(localizeWrapper('cDefaultNetworkError') + textStatus);
                mIsInError = false;
            }
            if (!lIsCatastrophic && !mIsInError && !isNullOrUndefined(aOnFailure)) {
                aOnFailure(aOutParams, XMLHttpRequest, textStatus, errorThrown, this);
            } else if (!lIsCatastrophic && !mIsInError && isNullOrUndefined(aOnFailure)) {
                window.location.hash = encodeURIComponent(window.location.hash);
            }
        }
    };
    if(aParams){
        req = Object.assign({'data':JSON.stringify(aParams)},req);
    }
    
    lRequest = $.ajax(req);

    return lRequest;
}

function callAjaxTest(aMethod, aParams, aOnSuccess, aOnFailure, aOutParams, aCheckState) {
    "use strict";
    var mStart = new Date(),
        mEnd = null,
        mMSeconds = 0,
        lCallState,
        lResponseState,
        lBypassState = false,
        lServiceUrl,
        lRequest;

    if (!isNullOrUndefined(mStateManager)) {
        lCallState = mStateManager.getSystemState();
    }
    initializeAjax();
    lServiceUrl = getServiceUrl();
    if (!isNullOrUndefined(lBypassState)) {
        lBypassState = !aCheckState;
    }
    var lLocation = window.location.origin + '/Veritracks.Service.Internal/Application.svc';

    if (lServiceUrl.indexOf("ds02") !== -1) {
        lLocation = lServiceUrl;
    }

    var lUrl = gServerList.threads + 'VeritracksThreadsApi/api/threads';

    lRequest = $.ajax({
        'type': 'POST',
        'url': lUrl,
        'dataType': 'json',
        'headers': {
            'token' :  veritracks.security.controller.tryGetSecurityToken(),
            'authServer': lLocation+'/'
        },
        'data': aParams,
        'async': true,
        'crossDomain': true,
        'success': function (aServiceObject) {
            mEnd = new Date();
            mMSeconds = mEnd.getTime() - mStart.getTime();
            //            if (typeof mActivityNotification !== 'undefined') {
            //                mActivityNotification.addNotification(aMethod + ' took ' + mMSeconds);
            //            }
            if (!isNullOrUndefined(mStateManager)) {
                lResponseState = mStateManager.getSystemState();
            }

            if (lBypassState || isPageStateStatic({ 'CallState': lCallState, 'ResponseState': lResponseState })) {
                if (!isNullOrUndefined(aOnSuccess)) {
                    if (!isNullOrUndefined(aServiceObject)) {
                        if (!isNullOrUndefined(aServiceObject.ExtraData)) {
                            aOnSuccess(aOutParams, aServiceObject.Data, aServiceObject.ExtraData, { 'CallState': lCallState, 'ResponseState': lResponseState });
                        }
                        else if (!isNullOrUndefined(aServiceObject.Data)) {
                            aOnSuccess(aOutParams, aServiceObject.Data, { 'CallState': lCallState, 'ResponseState': lResponseState });
                        } else {
                            aOnSuccess(aOutParams, aServiceObject, { 'CallState': lCallState, 'ResponseState': lResponseState });
                        }
                    } else {
                        aOnSuccess(aOutParams, aServiceObject);
                    }
                }
            }
        },
        'error': function (XMLHttpRequest, textStatus, errorThrown) {
            var lIsCatastrophic = catastrophicErrorHandler(XMLHttpRequest, textStatus, errorThrown);
            if (!lIsCatastrophic && !mIsInError && textStatus === 'timeout') {
                mIsInError = true;
                mActivityNotification.addNotification(localizeWrapper('cDefaultNetworkError') + textStatus);
                mIsInError = false;
            }
            if (!lIsCatastrophic && !mIsInError && !isNullOrUndefined(aOnFailure)) {
                aOnFailure(aOutParams, XMLHttpRequest, textStatus, errorThrown, this);
            } else if (!lIsCatastrophic && !mIsInError && isNullOrUndefined(aOnFailure)) {
                window.location.hash = encodeURIComponent(window.location.hash);
            }
        }
    });

    return lRequest;
}


function simulateFault() {
    "use strict";

    callAjax('FaultTest');
}